<template>
  <div>
    <WebHeaderView :title="info.title" />
    <div class="page-content">
        <div style="width: 96%;color: #fff;margin: 10px auto;">
      <div class="news-title-wrapper">
        <p class="title">{{ info.title }}</p>
        <p class="time">{{ info.created_at }}</p>
      </div>
      <p class="news-content" v-html="info.content"></p>
    </div>
    </div>
  </div>
</template>

<script>
import WebHeaderView from '@/components/Header/index.vue'
export default {
  name: 'NewInfView',
  components: { WebHeaderView },
  data () {
    return { info: {}, id: null }
  },
  mounted () {
    const query = this.$route.query
    if (query.id) {
      this.id = query.id
      this.getNotice()
    }
  },
  methods: {
    async getNotice () {
      await this.$http({
        method: 'post',
        url: 'noticeInfo',
        data: { id: this.id }
      }).then(data => {
        this.info = data.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.news-title-wrapper{
    line-height: 1.8;
    .title {
        font-size: .5rem;
        font-weight: 700;
    }
    .time{
        margin-top: 18px;
    }
}
.news-content{
    line-height: 1.4;
}
</style>
